var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonegroupGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160851",
    "data-name": "Group 160851",
    transform: "translate(-548 -884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160849",
    "data-name": "Group 160849"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_965",
    width: 22,
    height: 22,
    transform: "translate(548 884)",
    fill: "rgba(255,225,225,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "network-group-svgrepo-com",
    transform: "translate(548 872.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160848",
    "data-name": "Group 160848",
    transform: "translate(0 12.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83111",
    "data-name": "Path 83111",
    d: "M20.457,24.952a9.583,9.583,0,0,0-5.7-10.367,4.03,4.03,0,0,0-7.509,0,9.583,9.583,0,0,0-5.7,10.367A4.03,4.03,0,0,0,6.05,31.61a9.586,9.586,0,0,0,9.9,0,4.03,4.03,0,0,0,4.508-6.658ZM11,13.417a2.632,2.632,0,1,1-2.632,2.632A2.638,2.638,0,0,1,11,13.417ZM4.03,30.754a2.632,2.632,0,1,1,2.632-2.632A2.636,2.636,0,0,1,4.03,30.754Zm10.793-.112a8.194,8.194,0,0,1-7.646,0A4.037,4.037,0,0,0,2.86,24.265a8.183,8.183,0,0,1,4.116-7.991,4.03,4.03,0,0,0,8.048,0,8.181,8.181,0,0,1,4.116,7.991A4.037,4.037,0,0,0,14.823,30.642Zm3.147.112A2.632,2.632,0,1,1,20.6,28.121,2.632,2.632,0,0,1,17.97,30.754Z",
    transform: "translate(0 -12.019)",
    fill: "#787f88"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonegroupGrayIcon);
export default __webpack_public_path__ + "static/media/phone group_gray_icon.6602ca371c17cfec25d253801aa1108d.svg";
export { ForwardRef as ReactComponent };